import { render, staticRenderFns } from "./ProdConfirmationWindow.vue?vue&type=template&id=4982431b&"
import script from "./ProdConfirmationWindow.vue?vue&type=script&lang=js&"
export * from "./ProdConfirmationWindow.vue?vue&type=script&lang=js&"
import style0 from "./ProdConfirmationWindow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports